/** @jsx jsx */
import { jsx } from "theme-ui"
import React from "react"

const ToursAndEvents = ({ data }) => {
  const [isReady, setIsReady] = React.useState(false)
  const checkIfWindow = () => {
    if (typeof window !== "undefined") {
      return typeof window !== "undefined"
    }
    return typeof window !== "undefined"
  }

  React.useEffect(() => {
    if (checkIfWindow) {
      window.location.href = "/"
      setIsReady(true)
    }
  }, [])
  return isReady && <></>
}
export default ToursAndEvents


